import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import DEFINE, { CURRENCY, DATE_TIME_FORMAT } from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import * as ANT from 'antd';
import $ from 'jquery'
import moment from 'moment'
import { Link } from "react-router-dom";
import { maxBy } from 'lodash';
import * as VoucherComponent from "./CommonComponent";


class ViewComponent extends Component {

    state = {
        action: "CREATE",
        data: {},
        historyVoucher: { historyVoucher: {} },
        itemVoucher: {},
        allGroups: [],
        isSubmit: false,
        isFetching: false,
        isFetchingUpdate: false,
        isGetItem: false,
        validation: {},
        itemGroup: {},
        isUpload: false,
        isFetchingChange: false,
        isFetchingGetHistory: false,
        componentTable: {
            actionDate: {
                render: (text, record) => moment(moment.utc(text).toDate()).format('DD-MM-YYYY HH:mm:ss'),
            },
            actionId: {
                render: (text, r) => <ANT.Tag
                    color={this.props.t(`item.voucher.log.colorStatus.${text}`)}>{this.props.t(`item.voucher.log.${DEFINE.GENERAL.LOG_VOUCHER_ACTION[text]}`)}</ANT.Tag>
            }
        }
    };

    componentDidMount() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: "UPDATE" });
            this.props.onGetItemVoucher({ id: match.params.id, props: this.props });
            this.setState({
                idVoucher: match.params.id
            })
        }
    }

    validation = (field, reload) => {
        const { t } = this.props;
        let data = this.state.data;
        let result = {};
        if (!reload) {
            let validate = {
                required: {
                    note: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.voucher.note`)),
                }
            };
            let valueValidate = {};
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.vouchers.isSubmit,
            isFetchingGetHistory: nextProps.vouchers.isFetchingGetHistory,
            isGetItem: nextProps.vouchers.isGetItem,
            // isFetchingUpdate: nextProps.banners.isFetchingUpdate
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.vouchers.itemVoucher !== prevProps.vouchers.itemVoucher) {
            this.setState({
                itemVoucher: this.props.vouchers.itemVoucher,
                data: {
                    isLocked: this.props.vouchers.itemVoucher.isLocked,
                    id: this.props.vouchers.itemVoucher.id
                }
            })
        }
        if (this.props.vouchers.historyVoucher !== prevProps.vouchers.historyVoucher) {
            this.setState({
                historyVoucher: {
                    historyVoucher: this.props.vouchers.historyVoucher.result,
                    pageSize: this.props.vouchers.historyVoucher.pageSize,
                    pageIndex: this.props.vouchers.historyVoucher.pageIndex,
                    totalCount: this.props.vouchers.historyVoucher.totalCount,
                    totalPage: Math.ceil(parseInt(this.props.vouchers.historyVoucher.totalCount) / parseInt(this.props.vouchers.historyVoucher.pageSize)),
                },
            })

        }
    }

    onChange = (e) => {
        let params = Func.getValueForm(e);
        this.setState({
            data: {
                ...this.state.data,
                [params.name]: typeof params.value === 'string' ? params.value.trimLeft() : params.value,
            }
        });
        this.validation(params.name, true)
    };

    onSubmit = (e) => {
        e.preventDefault();
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            if (this.state.action === "UPDATE") {
                this.props.onUpdateVoucher({ data: this.state.data });
            }
        } else {
            ANT.message.error(i18n.t('validation.checkForm'))
        }
    };

    onPaginate = (pagination, filters, sorter) => {
        this.props.onGetHistory({ id: this.state.idVoucher, page: { PageIndex: pagination.current } });
    };

    render() {
        const { t } = this.props;
        const { data, validation, isSubmit, isGetItem, action, allGroups, historyVoucher, itemVoucher, componentTable, isFetchingGetHistory } = this.state;
        let discountVal = "---";
        if (itemVoucher) {
            switch (itemVoucher.voucherType) {
                case DEFINE.GENERAL.VOUCHER_TYPE.GIFT:
                    discountVal = t(`item.group.${DEFINE.GENERAL.VOUCHER_TYPE.GIFT}`);
                    break;
                case DEFINE.GENERAL.VOUCHER_TYPE.PERCENT:
                    discountVal = `${itemVoucher.discountValue}%`;
                    break;
                case DEFINE.GENERAL.VOUCHER_TYPE.MONEY:
                    discountVal = `${Func.formatMoney(itemVoucher.discountValue.toString())}`;
                    break;
                default:
                    discountVal = "---";
                    break;
            }
        }
        let compareUsed = itemVoucher && (itemVoucher.status === 7 && itemVoucher.usedCount >= itemVoucher.limitNumberOfTimes);
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit || isGetItem}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'vouchers'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.voucher.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.voucher.title')}`.toLowerCase()))
                            }
                        />
                        <HMS.FormActionComponent
                            propsButtonSubmit={{
                                disabled: compareUsed
                            }}
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            // action={action}
                            isGetItem={isGetItem}
                            findParentRoute={() => Func.findParentRoute('vouchers', this.props)}
                            submitButtonRight={true}
                        >
                            <HMS.FormWrapperItem>
                                <div className="col-md-12">
                                    <HMS.HeaderComponent title="1. Thông tin nhóm voucher" className="mb-3 p-2">
                                        <ANT.Divider />
                                        <div className="row">
                                            <div className="col-md-7">
                                                <ANT.Descriptions size="small" column={2}>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.serial')}>{itemVoucher.checkCode}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.group')}>{itemVoucher.groupName}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.discountValue')}>{discountVal}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.currencyCode')}>{t(`item.group.currencies.${CURRENCY[itemVoucher.currencyCode]}`)} ({CURRENCY[itemVoucher.currencyCode]})</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.limitNumberOfTimes')}>{itemVoucher.usedCount}/{itemVoucher.limitNumberOfTimes}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.operaBookingCode')}>{itemVoucher.operaBookingCode}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.startDate')}>{moment(moment.utc(itemVoucher.startDate).toDate()).format(`${DATE_TIME_FORMAT.SHORT_DATE}`)}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.checkInDate')}>{moment(moment.utc(itemVoucher.checkInDate).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.endDate')}>{moment(moment.utc(itemVoucher.endDate).toDate()).format(`${DATE_TIME_FORMAT.SHORT_DATE}`)}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.checkOutDate')}>{moment(moment.utc(itemVoucher.checkOutDate).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.property')}>{itemVoucher.properties && itemVoucher.properties.join(', ')}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.propertyOfStay')}>{itemVoucher.propertyOfStay ? itemVoucher.propertyOfStay.name : ''}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.createDate')}>{moment(moment.utc(itemVoucher.createdDate).toDate()).format(`${DATE_TIME_FORMAT.SHORT_DATE}`)}</ANT.Descriptions.Item>
                                                    <ANT.Descriptions.Item
                                                        label={t('item.voucher.checkedDate')}>{moment(moment.utc(itemVoucher.checkedDate).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)}</ANT.Descriptions.Item>
                                                    
                                                    
                                                </ANT.Descriptions>
                                            </div>
                                            <div className="col-md-5">
                                                <HMS.FormWrapperInputComponent
                                                    classLabel="lockeVoucher"
                                                    typeInput={true}
                                                    labelTitle={t(`item.voucher.lock`)}
                                                >
                                                    <HMS.CheckboxComponent onChange={this.onChange} name={`isLocked`}
                                                        disabled={compareUsed}
                                                        checked={data.isLocked} />
                                                </HMS.FormWrapperInputComponent>
                                                <HMS.FormWrapperInputComponent
                                                    isRequired={true}
                                                    isValidation={true}
                                                    dataValidation={data.note}
                                                    validation={validation.note}
                                                    labelTitle={t(`item.voucher.note`)}
                                                >
                                                    <textarea
                                                        disabled={compareUsed}
                                                        required
                                                        autoComplete="off"
                                                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.voucher.note")).toLowerCase())}
                                                        className={`form-control`}
                                                        name="note" onChange={this.onChange}
                                                        value={Func.checkUndefine(data.note)} />
                                                </HMS.FormWrapperInputComponent>
                                            </div>
                                        </div>
                                    </HMS.HeaderComponent>
                                </div>
                            </HMS.FormWrapperItem>
                        </HMS.FormActionComponent>
                        <div className="row">
                            <HMS.FormWrapperItem>
                                <div className="col-md-12">
                                    <HMS.HeaderComponent title="2. Thông tin lịch sử voucher" className="mb-3 p-2">
                                        <HMS.ListComponent
                                            className="historyVoucher"
                                            classChildren="p-0"
                                            loading={{ spinning: isFetchingGetHistory, size: 'large' }}
                                            rowKey={(record, k) => k}
                                            dataSource={Func.getDataSource(historyVoucher.historyVoucher, ['actionDate', 'actionBy', 'actionId', 'note'])}
                                            columns={Func.columnsTable({
                                                titleTable: ['actionDate', 'actionBy', 'actionId', 'note'],
                                                component: componentTable,
                                                itemName: 'voucher'
                                            })}
                                            onChange={this.onPaginate}
                                            pagination={{
                                                total: historyVoucher.totalCount,
                                                totalPage: historyVoucher.totalPage
                                            }}
                                            componentTableList={{
                                                right: ""
                                            }}
                                        />
                                    </HMS.HeaderComponent>
                                </div>
                            </HMS.FormWrapperItem>
                        </div>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        vouchers: state.voucherReducer,
        products: state.productReducer,
        groups: state.groupReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListAllGroups: (filters) => {
            dispatch(action.dataAllGroupAction(filters))
        },
        onGetGroup: (id) => {
            dispatch(action.getUpdateGroupAction(id))
        },
        onCreateVoucher: (params) => {
            dispatch(action.createVoucherAction(params))
        },
        onGetItemVoucher: (params) => {
            dispatch(action.getItemVoucherAction(params))
        },
        onGetHistory: (params) => {
            dispatch(action.getHistoryVoucherAction(params))
        },
        onUpdateVoucher: (params) => {
            dispatch(action.updateVoucherAction(params))
        },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ViewComponent)));
